import { render, staticRenderFns } from "./IconBaseInformative.vue?vue&type=template&id=347de3aa&"
import script from "./IconBaseInformative.vue?vue&type=script&lang=js&"
export * from "./IconBaseInformative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports